import { IDate } from "../../../models"

export interface IHRUserSearchParams {
    LevelIdFilter: string
    Page: number
    Limit: number
    Search: string
    IncludeTimecards: boolean
    ReferenceDate: IDate
    FilterByMissingPunches: boolean
    FilterByApproved: boolean
    FilterByNotApproved: boolean
    ActiveUsers: boolean
    FilterByDirectReports: boolean
    TempId: string
    HasTempId: boolean
    AccountUsers: boolean
    HasBadges: boolean
    EmployeeStatusFilters: IStatusFilterParam[]
    SupervisorIds: string[]
    RecruiterSupervisorIds: string[]
    ComplianceSupervisorIds: string[]
    AccountManagerSupervisorIds: string[]
    PayrollSupervisorIds: string[]
    SortFieldName: string
    SortDirection: string
    CallingUserId: string
    ModifiedStartDate: IDate
    ModifiedEndDate: IDate
    OriginalHireStartDate: IDate
    OriginalHireEndDate: IDate
    TerminationStartDate: IDate
    TerminationEndDate: IDate
    City: string
    State: string
    Zip: string
    ApplicationVerified: boolean
    BadgeFilterParams: IBadgeFilterParam[]
    OccupationIds: string[]
    SpecialtyIds: string[]
    IncludeUserIds: string[]
}

export interface IStatusFilterParam {
    StatusId: string
    SubStatusId: string
}

export interface IBadgeFilterParam {
    BadgeId: string
    Status: EBadgeFilterStatusEnum
}

export enum EBadgeFilterStatusEnum {
    NotStated = 0,
    Completed = 1,
    NotYetCompleted = 2,
    CompletedOrStarted = 3
}